export const mediaUrl = (mediaObject, transform, ext = 'png') =>
  `/api/media/${encodeURIComponent(mediaObject.public_id)}/${
    mediaObject.version
  }/${transform}.${ext}`;
